<template>
  <div v-if="lines.length" class="outlook-user-sync p-mb-3" id="outlookUserSync">
    <div v-for="(line, i) in lines" :key="i" class="outlook-sync-line">
      <strong v-if="line.label">{{ line.label }}:</strong>{{ line.text ? ' ' + line.text : '' }}<span
        v-if="line.problem" class="p-invalid">{{ ' ' + line.problem }}</span>
    </div>
  </div>
</template>

<script>
import OutlookSyncService from '@/service/OutlookSyncService'
import { userStatusLines } from './outlookSync'

// Under the two Outlook switches: how the sync is going for this user. The server shows it to an Admin for anyone
// and to a user for themselves; anything else (a 409, a failure) shows nothing.
export default {
  props: { userId: { type: [Number, String], default: null } },
  data: () => ({ status: null }),
  computed: {
    lines() { return userStatusLines(this.status) }
  },
  watch: {
    userId: { immediate: true, handler: 'load' }
  },
  methods: {
    load() {
      this.status = null
      if (this.userId === null || this.userId === undefined || this.userId === '') return Promise.resolve()
      if (!this.outlookSyncService) this.outlookSyncService = new OutlookSyncService()
      const asked = this.userId
      return this.outlookSyncService.userStatus(asked)
        .then(status => { if (asked === this.userId) this.status = status })
        .catch(() => { this.status = null })
    }
  }
}
</script>
